import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BreadcrumbService } from '../../../../shared/breadcrumbs/breadcrumb.service';
import { OrderEntryWebshopService } from '../../entry/webshop/order-entry-webshop.service';
import * as _ from 'underscore';
import { StateService } from '@uirouter/angular';
import { STATE_ORDERENTRY_CATALOG_OVERVIEW } from '../../../../shared/app-states';
import { BuyingGuideModel } from './buying-guide.model';
import { CatalogGuideDataService, ICatalogGuideChoice, ICatalogGuideData, ICatalogGuideMetaConfig } from './catalog-guide-data.service';
import { ScrollService } from '../../../../shared/scroll/scroll.service';

@Component({
  selector: 'catalog-guide',
  template: `
    <h2 *ngIf="loading">
      <span activity-indicator class="no-margin"></span>
      <span translate>GA.LOADING_SIMPLE</span>
    </h2>

    <div *ngIf="!loading">
      <div class="row">
        <div class="col-md-6">
          <button class="btn btn-primary guide-button" (click)="showAll()">
            Show complete catalog
          </button>
        </div>
      </div>

      <div *ngFor="let item of guideMetaData | keyvalue:itemOrder">
        <div [id]="item.key + '_choice'" class="choice" *ngIf="showLevel(item.key)" [scrollTarget]="item.key">
          <h2>{{ item.value.text }}</h2>
          <div class="row">
            <div class="col-md-3" *ngFor="let choice of item.value.choices; index as i">
              <button class="btn choice-button" [ngClass]="{'btn-info': getChoice(item.key) === i}" (click)="onChoice(item.key, i)">
                <span [innerHTML]="choice.text"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [ './catalog-guide.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class CatalogGuideComponent implements OnInit {
  private showProducts:boolean;
  private productsCategory:string;

  public guideMetaData:ICatalogGuideMetaConfig;
  public loading:boolean;

  constructor(
    private stateService:StateService,
    private catalogGuideDataService:CatalogGuideDataService,
    private breadcrumbService:BreadcrumbService,
    private orderEntryWebshopService:OrderEntryWebshopService,
    private buyingGuideModel:BuyingGuideModel,
    private scrollService:ScrollService
  ) {
  }

  public ngOnInit():void {
    this.loading = true;
    this.catalogGuideDataService.getConfig(this.orderEntryWebshopService.selectedShop.id)
      .then(data => {
        this.guideMetaData = data;
      })
      .finally(() => {
        this.loading = false;
      });

    if (_.isUndefined(this.buyingGuideModel.history())) {
      this.buyingGuideModel.init();
    }

    this.breadcrumbService.empty();
  }

  public getChoice(level:string):number {
    return this.buyingGuideModel.history().selections[ level ];
  }

  public onChoice(level:string, selection:number) {
    // when going back, we want to remove previous selections
    this.removeSelectionsOutsidePath(level);

    this.buyingGuideModel.history().selections[ level ] = selection;
    const choice:ICatalogGuideChoice = this.guideMetaData[ level ].choices[ selection ];
    this.handleChoice(choice);
  }

  public showLevel(level:string):boolean {
    if (level === 'root') {
      return true;
    }

    const previousLevel:string = this.getPreviousLevel(level);
    const previousSelection:number = this.buyingGuideModel.history().selections[ previousLevel ];
    return _.isUndefined(previousSelection)? false :
      level === this.guideMetaData[ previousLevel ].choices[ previousSelection ].next;
  }

  public showAll(): void {
    this.stateService.go(STATE_ORDERENTRY_CATALOG_OVERVIEW, {});
  }

  private removeSelectionsOutsidePath(level:string): void {
    const selectionsToKeep = {};
    let previousLevel:string = this.getPreviousLevel(level);
    while (previousLevel) {
      selectionsToKeep[previousLevel] = this.buyingGuideModel.history().selections[previousLevel];
      previousLevel = this.getPreviousLevel(previousLevel);
    }

    this.buyingGuideModel.history({
      selections: selectionsToKeep
    });
  }

  private handleChoice(choice:ICatalogGuideChoice):void {
    if (choice.orderType) {
      this.orderEntryWebshopService.shopContext.buyingGuide.orderType = choice.orderType;
    }

    this.assignCategory(choice.products);

    if (this.showProducts) {
      this.stateService.go(STATE_ORDERENTRY_CATALOG_OVERVIEW, this.searchParams());
    } else {
      this.scrollService.scrollTo(choice.next);
    }
  }

  private searchParams():any {
    const params:any = {};
    this.setGuideCode(params);
    return params;
  }

  private setGuideCode(params:any):void {
    if (this.productsCategory || this.productsCategory.length > 0) {
      const guide = this.productsCategory;
      params.guide = guide;
      this.buyingGuideModel.searchCode(guide);
      this.buyingGuideModel.showingAll(false);
    }
    params.layout = 'block';
  }

  private assignCategory(category?:string):void {
    this.productsCategory = _.isUndefined(category)? undefined : category;
    this.showProducts = !_.isUndefined(category);
  }

  private getPreviousLevel(level:string):string {
    if (level === 'root') {
      return undefined;
    }

    const matching:ICatalogGuideData[] = _.filter(this.guideMetaData, (guideData:ICatalogGuideData) => {
      return _.any(guideData.choices, (choice:ICatalogGuideChoice) => choice.next === level);
    }) || [];
    return _.findKey(this.guideMetaData, (guideData:ICatalogGuideData):boolean => {
      return guideData.text === (matching.length > 0? matching[ 0 ].text : undefined);
    });
  }

  public itemOrder = (): number => {
    return 0;
  };

}